import { ConfigProvider } from 'antd';
import { PropsWithChildren } from 'react';

export function AppLayout(props: PropsWithChildren<object>) {
  return (
    // <AuthContext value={authState}>
      <ConfigProvider
        /**
         * global theme override css
         * https://ant.design/docs/react/customize-theme
         *
         * During testing the variables in src/styles/theme.less and src/styles/palette.scss don't
         * impact the styles AntD uses
         */
        theme={{
          token: {
            colorPrimary: '#230056',
            colorPrimaryHover: '#A366FC',
            fontFamily: 'Comfortaa',
            colorTextPlaceholder: '#767679'
          },
          components: {
            Card: {
              headerFontSize: `${26 / 16}rem` as any
            },
            Button: {
              defaultColor: 'black'
            },
            Switch: {
              handleShadow: '0'
            }
          },
          cssVar: true
        }}
      >
        {props.children}
      </ConfigProvider>
  );
}
